import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Snowflake, UtensilsCrossed, CakeSlice, IceCream } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Reveal, Kicker } from "@/components/Reveal";
import { ASSETS } from "@/data/content";

const ICONS = [Snowflake, UtensilsCrossed, CakeSlice, IceCream];

const B2B = () => {
  const { t, dir } = useLang();
  const navigate = useNavigate();

  return (
    <section id="b2b" data-testid="b2b-section" className="relative py-24 md:py-32 bg-[#0F1B18] text-[#F0EDE4] overflow-hidden">
      <div className="absolute inset-0 -z-0 opacity-20">
        <img src={ASSETS.factoryImg} alt="" className="w-full h-full object-cover" />
      </div>
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <Reveal><Kicker className="text-[#C4A27A]">{t.b2b.kicker}</Kicker></Reveal>
            <Reveal delay={0.1}>
              <h2
                style={{ lineHeight: dir === "rtl" ? 1.25 : 1.1 }}
                className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight text-white mt-5"
              >
                {t.b2b.title}
              </h2>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="text-lg text-[#C3BEB2] mt-6 leading-relaxed max-w-md">{t.b2b.text}</p>
            </Reveal>
            <Reveal delay={0.2}>
              <button
                data-testid="b2b-cta"
                onClick={() => navigate("/contact")}
                className="mt-8 inline-flex bg-[#C4A27A] text-[#1A1A1A] px-8 py-4 hover:bg-[#D8B78C] transition-colors font-medium"
              >
                {t.b2b.cta}
              </button>
            </Reveal>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {t.b2b.items.map((item, i) => {
              const Icon = ICONS[i];
              return (
                <Reveal key={i} delay={0.1 + i * 0.08}>
                  <div className="border border-white/10 bg-white/5 backdrop-blur-sm p-8 h-full hover:bg-white/10 transition-colors group">
                    <Icon className="w-8 h-8 text-[#C4A27A] mb-5 group-hover:scale-110 transition-transform" />
                    <h3 className="font-display text-xl md:text-2xl text-white mb-2">{item.title}</h3>
                    <p className="text-sm text-[#B4AEA2] leading-relaxed">{item.text}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default B2B;
